import { render } from "./IntroThirdView.vue?vue&type=template&id=420fb526"
import script from "./IntroThirdView.vue?vue&type=script&lang=js"
export * from "./IntroThirdView.vue?vue&type=script&lang=js"

import "./IntroThirdView.vue?vue&type=style&index=0&id=420fb526&lang=css"

import exportComponent from "C:\\Users\\Emertat\\Desktop\\p\\nazerhelp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__